// src/pages/Sitemap.js
import React from 'react';
import { Link } from 'react-router-dom';

const SitemapPage = () => {
  return (
    <div className="container mx-auto px-6 py-20 min-h-screen bg-[#0A1128] text-[#F8F8F8]">
      <h1 className="text-4xl sm:text-5xl font-extrabold mb-8 text-[#C9B072] text-center md:text-left">Website Sitemap</h1>
      <div className="bg-[#1A2238] p-8 rounded-xl shadow-lg">
        <p className="text-lg leading-relaxed mb-6">
          This sitemap provides an overview of all the pages available on the JAKOM website, helping you navigate and find the information you need.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Main Pages */}
          <div>
            <h2 className="text-2xl font-bold text-[#F8F8F8] mb-4">Main Navigation</h2>
            <ul className="space-y-2 text-lg">
              <li><Link to="/" className="hover:text-[#C9B072] transition duration-300">Home</Link></li>
              <li><Link to="/about-us" className="hover:text-[#C9B072] transition duration-300">About Us</Link></li>
              <li><Link to="/contact-us" className="hover:text-[#C9B072] transition duration-300">Contact Us</Link></li>
              <li><Link to="/kids-hub" className="hover:text-[#C9B072] transition duration-300">Kids Hub</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h2 className="text-2xl font-bold text-[#F8F8F8] mb-4">Our Services</h2>
            <ul className="space-y-2 text-lg">
              <li><Link to="/graphics-design" className="hover:text-[#C9B072] transition duration-300">Graphics & Design</Link>
                <ul className="list-disc list-inside ml-4 text-base mt-1">
                  <li><Link to="/graphics-design/poster-gallery" className="hover:text-[#4CAF50] transition duration-300">Poster Gallery</Link></li>
                  <li><Link to="/graphics-design/video-editing" className="hover:text-[#4CAF50] transition duration-300">Video Editing</Link></li>
                  <li><Link to="/graphics-design/other-portfolio" className="hover:text-[#4CAF50] transition duration-300">Other Portfolio</Link></li>
                  <li><Link to="/graphics-design/image-tools" className="hover:text-[#4CAF50] transition duration-300">Image Tools (Background Remover)</Link></li>
                </ul>
              </li>
              <li><Link to="/data-analysis" className="hover:text-[#C9B072] transition duration-300">Data Analysis</Link></li>
              <li><Link to="/accounting-bookkeeping" className="hover:text-[#C9B072] transition duration-300">Accounting & Bookkeeping</Link></li>
              <li><Link to="/virtual-assistance" className="hover:text-[#C9B072] transition duration-300">Virtual Assistance</Link></li>
            </ul>
          </div>

          {/* Legal & Other */}
          <div>
            <h2 className="text-2xl font-bold text-[#F8F8F8] mb-4">Legal & Other</h2>
            <ul className="space-y-2 text-lg">
              <li><Link to="/privacy-policy" className="hover:text-[#C9B072] transition duration-300">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-[#C9B072] transition duration-300">Terms of Service</Link></li>
              <li><a href="#" className="hover:text-[#C9B072] transition duration-300">FAQ (Coming Soon)</a></li>
              <li><a href="#" className="hover:text-[#C9B072] transition duration-300">Support (Coming Soon)</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SitemapPage;
